// extracted by mini-css-extract-plugin
export var collapsedSummary = "_r6-0";